import t from "react";
import { t as e, c as s } from "./app-a75c1d35.mjs";
import { B as a } from "./Block-9b78bd10.mjs";
const p = "chart", E = "desktop", x = "chart__table", u = "chart__credits", y = "chart__source", c = {
  chart: p,
  desktop: E,
  chartTable: x,
  chartCredits: u,
  chartSource: y
};
function _({
  caption: l,
  thKey: n,
  thValue: o,
  rows: d,
  credits: m,
  source: h
}) {
  return /* @__PURE__ */ t.createElement(
    a,
    {
      topPadding: a.Padding.NONE,
      bottomPadding: a.Padding.LARGE,
      "data-testid": "article-page-chart"
    },
    /* @__PURE__ */ t.createElement(a.Content, null, /* @__PURE__ */ t.createElement("div", { className: c.chart }, /* @__PURE__ */ t.createElement("table", { className: c.chartTable, cellSpacing: 0 }, !!l && /* @__PURE__ */ t.createElement("caption", { className: e.textsBodyTextBold }, l), /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("th", { className: e.textsBodyTextBold }, n), /* @__PURE__ */ t.createElement("th", { className: e.textsBodyTextBold }, o))), /* @__PURE__ */ t.createElement("tbody", null, d.map((r, i) => /* @__PURE__ */ t.createElement("tr", { key: i + r.tdKey }, /* @__PURE__ */ t.createElement("td", { className: e.textsBodyText }, r.tdKey), /* @__PURE__ */ t.createElement("td", { className: e.textsBodyText }, r.tdValue))))), /* @__PURE__ */ t.createElement("span", { className: s(e.textsCaption, c.chartCredits) }, m), /* @__PURE__ */ t.createElement("span", { className: s(e.textsCaption, c.chartSource) }, h)))
  );
}
export {
  _ as ArticleChart
};
//# sourceMappingURL=ArticleChart.js.map
